import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Instagram, Linkedin, Mail, Phone, MessageCircle } from 'lucide-react';
import { Modal } from './ui/Modal';
import { Input } from './ui/Input';
import { Button } from './ui/Button';
export function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const handleSecretClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsAuthModalOpen(true);
    setError('');
    setPassword('');
  };
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === 'riezko') {
      setIsAuthModalOpen(false);
      navigate('/admin');
    } else {
      setError('Contraseña incorrecta');
      setPassword('');
    }
  };
  const handleServiceClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const element = document.getElementById('services');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('services');
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    }
  };
  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('contact');
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    }
  };
  return <footer className="bg-gray-900 text-white pt-8 pb-6 sm:pt-12 md:pt-20 sm:pb-8 md:pb-10 rounded-t-2xl sm:rounded-t-[2rem] md:rounded-t-[3rem]" data-id="element-352">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-353">
        <div className="grid grid-cols-1 gap-6 sm:gap-8 md:gap-12 md:grid-cols-2 lg:grid-cols-4 mb-6 sm:mb-10 md:mb-16" data-id="element-354">
          {/* Brand Column */}
          <div className="space-y-3 sm:space-y-4 md:space-y-6" data-id="element-355">
            <Link to="/" className="text-2xl sm:text-3xl font-black tracking-tighter text-white" data-id="element-356">
              FORAX<span className="text-blue-500" data-id="element-357">.</span>
            </Link>
            <p className="text-gray-400 leading-relaxed text-xs sm:text-sm md:text-base" data-id="element-358">
              Expertos en construcción corporativa. 40 años transformando
              visiones en realidad.
            </p>
            <div className="flex gap-3 sm:gap-4" data-id="element-359">
              <a href="http://linkedin.com/company/forax" target="_blank" rel="noopener noreferrer" className="h-8 w-8 sm:h-10 sm:w-10 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-blue-600 hover:text-white transition-all" aria-label="LinkedIn" data-id="element-360">
                <Linkedin className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-361" />
              </a>
              <a href="https://www.instagram.com/foraxcl" target="_blank" rel="noopener noreferrer" className="h-8 w-8 sm:h-10 sm:w-10 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-pink-600 hover:text-white transition-all" aria-label="Instagram" data-id="element-362">
                <Instagram className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-363" />
              </a>
            </div>
          </div>

          {/* Services Column - Hidden on mobile */}
          <div className="hidden md:block" data-id="element-364">
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4 lg:mb-6 text-white" data-id="element-365">
              Servicios
            </h3>
            <ul className="space-y-2 md:space-y-3 lg:space-y-4" data-id="element-366">
              <li data-id="element-367">
                <a href="/#services" onClick={handleServiceClick} className="text-gray-400 hover:text-blue-400 transition-colors text-sm md:text-base cursor-pointer" data-id="element-368">
                  Construcción Corporativa
                </a>
              </li>
              <li data-id="element-369">
                <a href="/#services" onClick={handleServiceClick} className="text-gray-400 hover:text-blue-400 transition-colors text-sm md:text-base cursor-pointer" data-id="element-370">
                  Habilitación de oficinas
                </a>
              </li>
              <li data-id="element-371">
                <a href="/#services" onClick={handleServiceClick} className="text-gray-400 hover:text-blue-400 transition-colors text-sm md:text-base cursor-pointer" data-id="element-372">
                  Retail y bancos
                </a>
              </li>
            </ul>
          </div>

          {/* Company Column - Simplified on mobile */}
          <div data-id="element-373">
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4 lg:mb-6 text-white" data-id="element-374">
              Empresa
            </h3>
            <ul className="space-y-2 md:space-y-3 lg:space-y-4" data-id="element-375">
              <li data-id="element-376">
                <Link to="/quienes-somos" className="text-gray-400 hover:text-blue-400 transition-colors text-xs sm:text-sm md:text-base" data-id="element-377">
                  Quiénes Somos
                </Link>
              </li>
              <li data-id="element-378">
                <Link to="/proyectos" className="text-gray-400 hover:text-blue-400 transition-colors text-xs sm:text-sm md:text-base" data-id="element-379">
                  Proyectos
                </Link>
              </li>
              <li data-id="element-380">
                <a href="/#contact" onClick={handleContactClick} className="text-gray-400 hover:text-blue-400 transition-colors text-xs sm:text-sm md:text-base cursor-pointer" data-id="element-381">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column - Simplified on mobile */}
          <div data-id="element-382">
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4 lg:mb-6 text-white" data-id="element-383">
              Contacto
            </h3>
            <ul className="space-y-2 md:space-y-3 lg:space-y-4" data-id="element-384">
              <li data-id="element-385">
                <a href="https://wa.me/56992180727" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 sm:gap-3 text-gray-400 hover:text-green-400 transition-colors text-xs sm:text-sm md:text-base group" data-id="element-386">
                  <MessageCircle className="h-4 w-4 sm:h-5 sm:w-5 text-green-500 group-hover:text-green-400 shrink-0" data-id="element-387" />
                  <span data-id="element-388">+56 9 9218 0727</span>
                </a>
              </li>
              <li data-id="element-389">
                <a href="mailto:contacto@forax.cl" className="flex items-center gap-2 sm:gap-3 text-gray-400 hover:text-blue-400 transition-colors text-xs sm:text-sm md:text-base group" data-id="element-390">
                  <Mail className="h-4 w-4 sm:h-5 sm:w-5 text-blue-500 group-hover:text-blue-400 shrink-0" data-id="element-391" />
                  <span data-id="element-392">contacto@forax.cl</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-4 sm:pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4" data-id="element-393">
          <button onClick={handleSecretClick} className="text-gray-500 text-xs sm:text-sm text-center md:text-left hover:text-gray-400 transition-colors cursor-default" aria-label="Admin access" data-id="element-394">
            © {new Date().getFullYear()} FORAX Construcción
          </button>
          <div className="flex gap-4 sm:gap-6 text-xs sm:text-sm text-gray-500" data-id="element-395">
            <a href="#" className="hover:text-white transition-colors" data-id="element-396">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-397">
              Términos
            </a>
          </div>
        </div>
      </div>

      <Modal isOpen={isAuthModalOpen} onClose={() => setIsAuthModalOpen(false)} title="Acceso Administrativo" data-id="element-398">
        <form onSubmit={handleLogin} className="space-y-4" data-id="element-399">
          <Input label="Contraseña" type="password" value={password} onChange={e => setPassword(e.target.value)} error={error} placeholder="Ingrese contraseña de acceso" autoFocus data-id="element-400" />
          <div className="flex justify-end gap-3 pt-2" data-id="element-401">
            <Button type="button" variant="secondary" onClick={() => setIsAuthModalOpen(false)} data-id="element-402">
              Cancelar
            </Button>
            <Button type="submit" data-id="element-403">Ingresar</Button>
          </div>
        </form>
      </Modal>
    </footer>;
}